// @ts-nocheck

import { createSelector } from 'reselect';

import { type StateType } from '../../../../states';
import { selectKLUserRoundIndex, selectKLUserVotes } from '../user';

const getRoundIndexFromProps = (_: StateType, { roundIndex }) => roundIndex;

const selectShouldDisplayValues = createSelector(
  [getRoundIndexFromProps, selectKLUserRoundIndex],
  (roundIndex, userRoundIndex) => roundIndex === userRoundIndex,
);

const selectUserVotesAgainstHimselfNumber = createSelector(
  [selectKLUserVotes, selectShouldDisplayValues],
  (nbVotes, shouldDisplayValues) => (shouldDisplayValues ? nbVotes : 0),
);

const selectKLCollarProps = createSelector([selectUserVotesAgainstHimselfNumber], (counter) => ({
  counter,
}));

export default selectKLCollarProps;
